import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export function USViewWorkspaceActiveSubscription() {
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return (
    <div>
      {t(i18n_page_settings_workspace.tabs.credits.general_component.active_subscription)}:{' '}
      {t(i18n_page_settings_workspace.tabs.subscription.type[workspace_current.activated_subscription])}
    </div>
  );
}
